import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";


interface LanguageLevels {
    beginLanguageLevel: string;
    currentLanguageLevel: string;
}

export interface UpdateLevelParamsWithGroupId {
    studentId: string | undefined;
    newLevel: LanguageLevels;
    groupId: string | undefined;
}


export const fetchLevelUpdate = createAsyncThunk(
    'student/levelUpdate',
    async ({ studentId, newLevel, groupId }: UpdateLevelParamsWithGroupId, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.put(
                `/api/groups/${groupId}/student-info/${studentId}/level`,
                {
                    beginLanguageLevel: newLevel.beginLanguageLevel,
                    currentLanguageLevel: newLevel.currentLanguageLevel,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);